document.addEventListener("DOMContentLoaded", function() {
  $(".choice_row").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
  });

  const $sample_atc_submit_event = async function ($form_data) {
    const $sample_addtocart_result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify($form_data),
    });

    const $atc_success_result = await $sample_addtocart_result.json();
    console.log("$sample_addtocart_result", $atc_success_result);
    if ($atc_success_result.items) {
      if (
        document.querySelector("cart-drawer") &&
        document.querySelector("cart-drawer").classList.contains("is-empty")
      )
        document.querySelector("cart-drawer").classList.remove("is-empty");
      const quickAddModal = document.querySelector("quick-add-modal");

      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              document
                .querySelector("cart-drawer")
                .renderContents($atc_success_result);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        document
          .querySelector("cart-drawer")
          .renderContents($atc_success_result);
      }
      flash("Product added!");
    } else {
      console.error($atc_success_result);
    }
  };
  
  $(document).on("click", ".trigger_btn", function (e) {
    e.preventDefault(), e.stopImmediatePropagation();
    //console.log("Hello");
    let sample_product_atc_array = [];
    let vals = $(this).parents("form").find(".main_product_id").val();
    let mainProp = $(this)
      .parents(".product__info-wrapper ")
      .find(".product-form__input  input:checked")
      .attr("data-vals");
    let subText = $(this)
      .parents(" .product__info-wrapper ")
      .find(" .choice_item input:checked")
      .attr("data-property");

    let specialGift_Id = $(this)
      .parents(" .product__info-wrapper ")
      .find(" .special-gift-product")
      .attr("data-special-gift");

    

    if ($(".choice_row.active input").val() != "") {
      $(".choice_row.active").each(function () {
        if($(this).find("input").attr("data-selling-plan-id") != ''){
          var sellingPlanId = $(this).find("input").attr("data-selling-plan-id");
        }
        sample_product_atc_array.push({
          id: $(this).find("input").val(),
          quantity: 1,
          properties: {
            //_Product_Plan: mainProp,
            //_subscription: $(this).find("input").attr("data-sub"),
            _subscription_plan: subText,
          },
          selling_plan: sellingPlanId
        });
      });
    }
    /*sample_product_atc_array.push({
      id: vals,
      quantity: 1,
      properties: {
        _Product_Plan: mainProp,
        _subscription_plan: subText,
      },
    });*/
    
    let sample_product_atc_formData = {
      items: sample_product_atc_array,
      sections_url: window.location.pathname,
      sections: document
        .querySelector("cart-drawer")
        .getSectionsToRender()
        .map((section) => section.id),
    };
    $sample_atc_submit_event(sample_product_atc_formData);
  });

  $(document).on("click", ".cart_drawer_remove_btn", function (e) {
    e.preventDefault(), e.stopImmediatePropagation();
    let dataName = $(this).parents(".cart-item").attr("data-remove");
    var data = { updates: {} };
    if (!dataName) {
      let allData = $(this).parents(".cart-item").attr("data-key");
      data.updates[allData] = 0;
    } else {
      let allData = $(`.cart-item[data-remove = ${dataName}]`);
      allData.each(function (index, elem) {
        let vals = $(this).attr("data-key");
        data.updates[vals] = 0;
      });
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function (cart) {
        $.getJSON("/cart.js", function (cart) {
          $(".cart-count-bubble span[aria-hidden='true']").text(cart.item_count)
          if (cart.item_count <= 0) {
            $("cart-drawer").addClass("is-empty");
          } else {
            $("cart-drawer").removeClass("is-empty");
          }
        });
        flash("Product deleted!");
        load_cart();
      },
    });
  });
});
